var samsung_AA59_00638A = {
    name: "AA59_00638A",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [67,0,4,151,2,187,1,147,2,43,6,20,18,37,17,147,2,0,0,42,253,95,223,218,170,136],
        },
        {
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [67,0,4,135,2,203,1,127,2,64,6,41,18,64,17,124,2,0,0,42,253,95,191,234,170,136],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [67,0,4,155,2,182,1,150,2,42,6,53,18,38,17,148,2,0,0,42,253,95,239,214,170,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [67,0,4,151,2,197,1,160,2,16,6,11,18,49,17,169,2,0,0,42,253,95,183,246,170,136],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [67,0,4,148,2,198,1,162,2,18,6,21,18,10,17,175,2,0,0,42,253,95,215,238,170,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [67,0,4,155,2,182,1,154,2,42,6,56,18,11,17,147,2,0,0,42,253,95,247,213,170,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [67,0,4,145,2,202,1,151,2,23,6,232,17,90,17,183,2,0,0,42,253,95,187,245,170,136],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [67,0,4,149,2,201,1,153,2,18,6,231,17,86,17,167,2,0,0,42,253,95,219,237,170,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [67,0,4,151,2,196,1,163,2,16,6,254,17,51,17,169,2,0,0,42,253,95,235,235,170,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [67,0,4,149,2,198,1,159,2,18,6,40,18,19,17,170,2,0,0,42,253,95,181,251,170,136],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [67,0,4,149,2,197,1,156,2,20,6,226,17,95,17,168,2,0,0,42,253,95,213,247,170,136],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [67,0,4,160,2,176,1,154,2,41,6,38,18,32,17,149,2,0,0,42,253,95,189,245,106,136],
        },
        {
            function: "KEY_TTX",
            name: "KEY_TTX",
            icon: "KEY_TTX",
            command: [67,0,4,136,2,197,1,135,2,59,6,13,18,49,17,127,2,0,0,42,253,95,235,117,218,136],
        },
        {
            function: "KEY_PRECH",
            name: "KEY_PRECH",
            icon: "KEY_PRECH",
            command: [67,0,4,146,2,188,1,147,2,46,6,9,18,41,17,146,2,0,0,42,253,95,174,253,106,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [67,0,4,148,2,196,1,159,2,20,6,9,18,55,17,168,2,0,0,42,253,95,171,254,170,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [67,0,4,158,2,191,1,157,2,18,6,57,18,27,17,169,2,0,0,42,253,95,173,253,170,136],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [67,0,4,151,2,181,1,155,2,43,6,25,18,33,17,149,2,0,0,42,253,95,221,237,106,136],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [67,0,4,134,2,202,1,130,2,67,6,26,18,31,17,123,2,0,0,42,253,95,251,213,106,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [67,0,4,149,2,189,1,144,2,47,6,17,18,57,17,142,2,0,0,42,253,95,170,255,170,136],
        },
        {
            function: "KEY_CHLIST",
            name: "KEY_CHLIST",
            icon: "KEY_CHLIST",
            command: [67,0,4,141,2,191,1,142,2,53,6,39,18,52,17,142,2,0,0,42,253,95,173,175,110,136],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [67,0,4,138,2,196,1,139,2,56,6,33,18,56,17,137,2,0,0,42,253,95,218,246,234,136],
        },
        {
            function: "KEY_APPS",
            name: "KEY_APPS",
            icon: "KEY_APPS",
            command: [67,0,4,133,2,200,1,129,2,67,6,0,18,54,17,123,2,0,0,42,253,95,186,174,190,136],
        },
        {
            function: "KEY_GUIDE",
            name: "KEY_GUIDE",
            icon: "KEY_GUIDE",
            command: [67,0,4,137,2,197,1,133,2,60,6,253,17,53,17,133,2,0,0,42,253,95,170,239,214,136],
        },
        {
            function: "KEY_TOOLS",
            name: "KEY_TOOLS",
            icon: "KEY_TOOLS",
            command: [67,0,4,139,2,193,1,142,2,55,6,9,18,58,17,136,2,0,0,42,253,95,173,222,214,136],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [67,0,4,141,2,195,1,136,2,54,6,36,18,55,17,138,2,0,0,42,253,95,170,191,234,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [67,0,4,140,2,195,1,127,2,64,6,4,18,60,17,127,2,0,0,42,253,95,253,106,174,136],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [67,0,4,135,2,206,1,135,2,50,6,255,17,39,17,136,2,0,0,42,253,95,183,93,174,136],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [67,0,4,133,2,207,1,134,2,50,6,3,18,62,17,141,2,0,0,42,253,95,190,186,174,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [67,0,4,135,2,205,1,133,2,49,6,252,17,68,17,143,2,0,0,42,253,95,222,182,174,136],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [67,0,4,129,2,207,1,127,2,70,6,255,17,68,17,119,2,0,0,42,253,95,246,181,110,136],
        },
        {
            // function: "KEY_RETURN",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [67,0,4,132,2,202,1,135,2,58,6,254,17,57,17,135,2,0,0,42,253,95,245,181,118,136],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [67,0,4,138,2,193,1,140,2,57,6,37,18,48,17,136,2,0,0,42,253,95,181,189,218,136],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [67,0,4,139,2,195,1,140,2,55,6,16,18,58,17,140,2,0,0,42,253,95,235,90,238,136],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [67,0,4,142,2,192,1,145,2,52,6,30,18,15,17,136,2,0,0,42,253,95,237,235,106,136],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [67,0,4,130,2,202,1,133,2,62,6,3,18,54,17,126,2,0,0,42,253,95,182,251,106,136],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [67,0,4,139,2,194,1,141,2,55,6,9,18,47,17,135,2,0,0,42,253,95,214,247,106,136],
        },
        {
            function: "KEY_HISTORY",
            name: "KEY_HISTORY",
            icon: "KEY_HISTORY",
            command: [67,0,4,134,2,201,1,131,2,64,6,9,18,57,17,146,2,0,0,42,253,95,251,85,91,136],
        },
        {
            function: "KEY_FAMILYSTORY",
            name: "KEY_FAMILYSTORY",
            icon: "KEY_FAMILYSTORY",
            command: [67,0,4,137,2,199,1,132,2,60,6,28,18,50,17,147,2,0,0,42,253,95,215,171,171,136],
        },
        {
            function: "KEY_CAMERA",
            name: "KEY_CAMERA",
            icon: "KEY_CAMERA",
            command: [67,0,4,154,2,188,1,169,2,14,6,35,18,31,17,167,2,0,0,42,253,95,213,123,234,136],
        },
        {
            function: "KEY_SUPPORT",
            name: "KEY_SUPPORT",
            icon: "KEY_SUPPORT",
            command: [67,0,4,168,2,171,1,155,2,32,6,33,18,30,17,145,2,0,0,42,253,95,170,175,250,136],
        },
        {
            function: "KEY_AD_SUBT",
            name: "KEY_AD_SUBT",
            icon: "KEY_AD_SUBT",
            command: [67,0,4,163,2,171,1,167,2,27,6,32,18,30,17,147,2,0,0,42,253,95,183,123,90,136],
        },
        {
            function: "KEY_3D",
            name: "KEY_3D",
            icon: "KEY_3D",
            command: [67,0,4,134,2,202,1,130,2,62,6,251,17,52,17,140,2,0,0,42,253,95,170,187,245,136],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [67,0,4,126,2,206,1,126,2,71,6,250,17,70,17,119,2,0,0,42,253,95,183,187,86,136],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [67,0,4,127,2,205,1,132,2,69,6,27,18,25,17,118,2,0,0,42,253,95,219,182,214,136],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [67,0,4,132,2,205,1,135,2,54,6,253,17,64,17,134,2,0,0,42,253,95,247,106,214,136],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [67,0,4,130,2,202,1,133,2,63,6,254,17,55,17,123,2,0,0,42,253,95,187,186,214,136],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [67,0,4,138,2,195,1,131,2,62,6,29,18,62,17,126,2,0,0,42,253,95,171,223,86,136],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [67,0,4,145,2,189,1,148,2,46,6,15,18,47,17,145,2,0,0,42,253,95,215,183,86,136],
        },
    ]
}
export default samsung_AA59_00638A